import { bffApi } from "../../autogen/bff-api";
import type { UpdateSourcingEventApiArg } from "../../autogen/bff-api";

export const tagsInvalidatedByUpdate = (arg: Pick<UpdateSourcingEventApiArg, "dryRun">) =>
  arg.dryRun ? [] : (["SourcingEvent"] as const);

bffApi.enhanceEndpoints({
  endpoints: {
    updateSourcingEvent: {
      invalidatesTags: (_result, _error, arg) => [...tagsInvalidatedByUpdate(arg)],
    },
  },
});
